// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"562a46ff","977":"3c1a348c"}[chunkId] + ".chunk.js";
};